import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";

import Service from "../../../../api/api-service";
import { ApiUrl } from "../../../../api/api-url";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";

const service = new Service();

export const NOTIFICATION_GET_LIST_ALL_OK = "NOTIFICATION_GET_LIST_ALL_OK";
export const NOTIFICATION_GET_LIST_ALL_ERR = "NOTIFICATION_GET_LIST_ALL_ERR";

export function notificationGetListAllOk(payload) {
  return {
    type: NOTIFICATION_GET_LIST_ALL_OK,
    payload,
  };
}

export function notificationGetListAllErr(payload) {
  return {
    type: NOTIFICATION_GET_LIST_ALL_ERR,
    payload,
  };
}

export const notificationGetListAllService = {
  getListAll,
};

function getListAll(params) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .post(ApiUrl.NotificationGetListAll, params)
      .then((response) => {
        dispatch(notificationGetListAllOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(notificationGetListAllErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        ShowNotification(error.errorMessage, NotificationMessageType.Error);
      });
  };
}
